	
<template>
  <router-view :pager="app.pager" />
</template>

<style>
body {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>

<script>
import { App } from "@/js/App.js";

export default {
  data() {
    return {
      app: new App(),
    };
  },
  mounted() {
    this.app.initialize();
  },
  beforeMount() {
    this.app.destroy();
  },
  methods: {},
  components: {},
};
</script>